export class Health {
  private value: number;

  constructor(readonly max: number) {
    if (max <= 0) throw new RangeError('Health must be above zero');
    this.value = max;
  }

  get current(): number {
    return this.value;
  }

  get isEmpty(): boolean {
    return this.value === 0;
  }

  get fraction(): number {
    return this.value / this.max;
  }

  take(damage: number): void {
    if (damage < 0) throw new RangeError('Damage cannot be negative');
    this.value = Math.max(0, this.value - damage);
  }

  heal(amount: number): void {
    if (amount < 0) throw new RangeError('Healing cannot be negative');
    this.value = Math.min(this.max, this.value + amount);
  }
}
